<div class="menu">
    <div class="item" *ngFor="let m of getMenuItems()">
      <div matRipple class="inner" (click)="onItemClick(m)" (keyup.enter)="onItemClick(m)" tabindex="0" [ngClass]="{active: selectedMenuItem === m}">
        {{m.title | translate}}
      </div>
    </div>
</div>
